var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1424 28.0002C43.1424 20.2554 46.718 15.9042 49.518 15.9042H53.2C51.3296 12.939 49.7812 11.2002 42.9576 11.2002H14.9352C4.48 11.2002 0 20.835 0 28.0002C0 35.1654 4.48 44.8002 14.9352 44.8002H42.9576C49.784 44.8002 51.3296 43.0614 53.2 40.0962H49.518C46.718 40.0962 43.1424 35.745 43.1424 28.0002ZM35.5264 33.0262C35.0672 33.7262 33.6336 33.071 33.6336 33.071L25.354 29.3246C25.354 29.3246 24.6148 31.2006 24.0464 32.5194C23.4724 33.8382 23.0356 35.3306 20.6612 33.6618C18.284 31.9874 10.6344 24.5618 10.6344 24.5618C10.6344 24.5618 9.6684 23.7666 10.15 23.019C10.6064 22.3134 12.0428 22.9742 12.0428 22.9742L20.3196 26.715C20.3196 26.715 21.0616 24.8446 21.63 23.5258C22.204 22.2098 22.6408 20.709 25.0152 22.3834C27.3924 24.0522 35.0392 31.4834 35.0392 31.4834C35.0392 31.4834 36.0052 32.2758 35.5264 33.0262ZM52.8472 22.1986H50.75C49.1848 22.1986 47.656 24.3098 47.656 27.7398C47.656 31.1754 49.1876 33.2838 50.75 33.2838H52.8472C54.4152 33.2838 56 31.1726 56 27.7398C56 24.307 54.4152 22.1986 52.8472 22.1986Z",
    fill: "#9021FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryBig);
export default __webpack_public_path__ + "static/media/batteryBig.8bc5668f49c9836987c6e6343572d65a.svg";
export { ForwardRef as ReactComponent };